import styled from 'styled-components';

export const AnimationWrapper = styled.div`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  z-index: 1;
`;
